import axios from 'axios';

export const createPin = async (accessToken, pin) => {
  const { data } = await axios.put(
    `${Env.API_URL}/auth/pin`,
    {
      pin,
    },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
  return data;
};

export const profileForgotpassword = async (payload) => {
  const { data } = await axios.post(
    `${Env.API_URL}/auth/client-app-forgot`,
    payload
  );

  return data;
};

export const profileForgotpasswordUpdate = async (payload) => {
  const { data } = await axios.put(
    `${Env.API_URL}/auth/client-app-updatePassword`,
    payload
  );

  return data;
};
